<div class="xl-content chart-table-viewport">
    <table #table class="table table-bordered m-0 text-center">
        <thead class="sticky-top">
            <tr>
                <th class="fit" style="width: 100px;">Period</th>
                <th [colSpan]="this.previousComparePeriod.length > 0 ? 3 : 1" *ngFor="let col of columns(); index as i; trackBy: trackByIndex" class="notranslate">
                    {{col}}
                </th>
            </tr>
            <tr *ngIf="previousComparePeriod.length > 0" id="top-header" class="notranslate">
                <th></th>
                <ng-container *ngFor="let col of columns(); index as i; trackBy: trackByIndex">
                    <th>{{comparisonLabels?.previous || calculatedColumnTimes[0].previous}}</th>
                    <th>{{comparisonLabels?.current || calculatedColumnTimes[0].current}}</th>
                    <th>{{comparisonLabels?.difference || '%'}}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody class="overflow-auto notranslate">
            <ng-container *ngFor="let row of records(currentPeriod, previousComparePeriod); index as i; trackBy : trackBy">
                <ng-container *ngIf="previousComparePeriod.length > 0 && row.periodChange">
                    <tr class="sticky-top table-header" [style.top]="headerTop">
                        <th></th>
                        <ng-container *ngFor="let col of columns(); index as j; trackBy: trackByIndex">
                            <th>{{comparisonLabels?.previous || calculatedColumnTimes[i].previous}}</th>
                            <th>{{comparisonLabels?.current || calculatedColumnTimes[i].current}}</th>
                            <th>{{comparisonLabels?.difference || '%'}}</th>
                        </ng-container>
                    </tr>
                </ng-container>
                <tr>
                    <td class="fit text-center">{{row.label}}</td>
                    <ng-container *ngIf="previousComparePeriod.length > 0 else normalView">
                        <ng-container *ngFor="let record of row.data; index as j; trackBy: trackByIndex">
                            <td data-t="n" [attr.data-v]="record.prevVal">{{record.prevVal | number:record.digitsInfo}}</td>
                            <td data-t="n" [attr.data-v]="record.val">{{record.val | number:record.digitsInfo}}</td>
                            <td [attr.data-t]="record.finite ? 'n' : null"
                                [attr.data-v]="record.finite ? record.percentage / 100 : null"
                                [attr.data-z]="record.finite ? '0.0%' : null">
                                <span *ngIf="record.finite else nullValue" [ngClass]="record.cssClass">
                                    {{record.percentage | number}}%
                                </span>
                                <ng-template #nullValue>
                                    <span>-</span>
                                </ng-template>
                            </td>
                        </ng-container>
                    </ng-container>
                    <ng-template #normalView>
                        <ng-container *ngFor="let val of row.data; index as j; trackBy: trackByIndex">
                            <td data-t="n" [attr.data-v]="val.val">{{val.val | number:val.digitsInfo}}</td>
                        </ng-container>
                    </ng-template>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
